import PricingListItem from '../../../../Domain/PricingListItem';
import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../../Helpers/ValidityHelper';
import PricingService from '../../../../Services/PricingService';

// Drives the GeneralEditWizzardBaseFigma bulk "ManDay Multi Update" action panel. The man-day
// fields carry isCheckBoxEnabled so each is opted in/out of the multi-update; the Distribution
// select is required and controls how the entered values are spread across the selected pricings.
export default class ManDayMultiUpdateWindowDescription {
  static titleForCreate = 'ManDay Multi Update';
  static titleForEdit = 'ManDay Multi Update';
  static finishButtonLabel = 'Save';
  static itemType = PricingListItem;
  static serviceFunction = (edited) => PricingService.MultiplePost(edited);
  static messageOnSuccess = 'Pricing has been updated!';

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        //Tier
        {
          fieldName: 'SeniorProjectMgrDays',
          label: 'Senior Project Mgr Days',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.emptyValidityChecker,
          isCheckBoxEnabled: true,
        },
        {
          fieldName: 'ProjectMgrDays',
          label: 'Project Mgr Days',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.emptyValidityChecker,
          isCheckBoxEnabled: true,
        },
        {
          fieldName: 'OperationsMgrDays',
          label: 'Operations Mgr Days',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.emptyValidityChecker,
          isCheckBoxEnabled: true,
        },
        {
          fieldName: 'AssistantProjectMgrDays',
          label: 'Assistant Project Mgr Days',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.emptyValidityChecker,
          isCheckBoxEnabled: true,
        },
        {
          fieldName: 'RecruiterDays',
          label: 'Recruiter Days',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.emptyValidityChecker,
          isCheckBoxEnabled: true,
        },
        {
          fieldName: 'DataCheckerDays',
          label: 'Data Checker Days',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.emptyValidityChecker,
          isCheckBoxEnabled: true,
        },
        {
          fieldName: 'Distribution',
          label: 'Distribution',
          className: 'col-12',
          type: InputTypesEnum.Select,
          selectvalues: ManDayMultiUpdateWindowDescription.getSelectOptions(),
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
      ],
    },
  ];

  static getSelectOptions() {
    return [
      {
        label: 'Choose one...',
        value: '',
        disabled: false,
      },
      {
        label: 'Apply evenly',
        value: 'evenly',
        disabled: false,
      },
      {
        label: 'Apply the same',
        value: 'applyTheSame',
        disabled: false,
      },
    ];
  }
}
